import React, { useState, useReducer, useEffect } from 'react';
import { creatNewBrand, updateBrandDetails } from '../../../../utils/ServicesAPIUtils';
import { IconButton, Button, Tabs, Tab } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import './Brand-Create.scss';
import { useSelector, useDispatch } from 'react-redux';
import {
  allGroupsSelector,
  fetchAllProperties,
  selectedGroupSelector,
  selectedHotelSelector,
} from '../../propertySlice';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { ASSET_BRANDS, BRAND_CREATE } from '../../../../constants/PropertyConst';
import ImageUpload from '../../../../shared/image-upload/ImageUpload';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { formDataValidate } from '../../../../utils/formUtils';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { getProcessedImages } from '../../../../shared/image-upload/ImageProcessor';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';
import { ASSET_TYPE_PROPERTY } from '../../../../constants/PropertyConst';
import { getPreSignedUrl } from '../../../../utils/PropertyAPIUtils';
import { convertFileToBase64 } from '../../../../utils/commonUtils';
import { ASSET_URL } from '../../../../env/Configurations';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../utils/mediaUtils';

const BrandCreate = (props) => {
  const { toggleDrawer, brand, showLoader = () => {} } = props;
  const lstGroup = useSelector(allGroupsSelector);
  const hotelId = decryptLocalStorage('hotelId');
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectedGroup = useSelector(selectedGroupSelector);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    groupId: {
      value: '',
      fieldName: 'Select Hotel Group',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Brand Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Brand Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 2,
    },
  });

  useEffect(() => {
    if (brand) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = brand[field];
      }
      currFields.images.value = brand.images || [];
      const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
        brand?.mediaContent,
      );
      const videoData = videoMediaContent || brand.videos || {};
      const gifData = gifMediaContent || brand.gifs || {};
      setVideoImageUrl(videoData?.imageUrl || '');
      setGifImageUrl(gifData?.imageUrl || '');
      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));
      setFormData(currFields);
    }
  }, [brand]);

  useEffect(() => {
    if (!brand && selectedGroup) {
      const currFields = { ...formData };
      currFields.groupId.value = selectedGroup;
      setFormData(currFields);
    }
  }, [brand, selectedGroup]);

  const validate = (tabValue) => {
    const updatedFields = {};
    // If tabValue is given, filter out the form fields in current tab
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );

    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images.value];
    images.splice(index, 1);
    setFormData({ images: { ...formData.images, value: images } });
  };

  const handleSubmit = async (e) => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    e.preventDefault();
    if (validate(0)) {
      toggleDrawer('', false, '');

      const payload = {};

      for (let field in formData) {
        payload[field] = formData[field].value;
      }

      try {
        dispatch(stepUpLoaderCount());
        payload.images = await getProcessedImages(
          rawImages,
          formData.groupId.value,
          ASSET_BRANDS,
          hotelId,
        );
        const gifData = await processGifsForUpload({
          rawGifs,
          groupId: formData.groupId.value,
          propertyType: ASSET_BRANDS,
          hotelId,
        });

        const mediaContent = toMediaContent({
          videoList: rawVideos,
          videoImageUrl,
          gifList: gifData,
          gifImageUrl,
        });
        if (Array.isArray(brand?.mediaContent)) {
          const valueByKey = mediaContent.reduce((acc, r) => ((acc[r.key] = r.value), acc), {});
          const merged = brand.mediaContent.map((row) => {
            if (row?.key === 'Video' && valueByKey.Video !== undefined)
              return { ...row, value: valueByKey.Video };
            if (row?.key === 'GIF' && valueByKey.GIF !== undefined)
              return { ...row, value: valueByKey.GIF };
            return row;
          });
          if (!brand.mediaContent.some((r) => r?.key === 'Video') && valueByKey.Video)
            merged.push({ key: 'Video', value: valueByKey.Video });
          if (!brand.mediaContent.some((r) => r?.key === 'GIF') && valueByKey.GIF)
            merged.push({ key: 'GIF', value: valueByKey.GIF });
          payload.mediaContent = merged;
        } else {
          payload.mediaContent = mediaContent;
        }
        try {
          const v = JSON.parse(
            (payload.mediaContent.find((x) => x.key === 'Video') || {}).value || '{}',
          );
          const g = JSON.parse(
            (payload.mediaContent.find((x) => x.key === 'GIF') || {}).value || '{}',
          );
          payload.videos = v;
          payload.gifs = g;
        } catch {}

        if (brand) {
          payload.id = brand?.id;
          await updateBrandDetails(payload, language);
          notificationManager('success', 'Brand updated successfully');
        } else {
          await creatNewBrand(payload, language);
          notificationManager('success', 'Brand created successfully');
        }
        dispatch(fetchAllProperties());
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          brand
            ? notificationManager('danger', 'Brand updation failed')
            : notificationManager('danger', 'Brand creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer(BRAND_CREATE, false, '');
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else if (validate(tabValue)) {
      setTabValue(newValue);
    }
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form className='brand-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-3'>
            <span className='page-title'>{brand ? 'Edit Brand' : 'Add Brand'}</span>
          </div>
          <div className='col-md-8'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='brands-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.groupId}
                    handleInputChange={(e) => {
                      setFormData({ groupId: e });
                    }}
                    options={lstGroup}
                    hideNullOption={lstGroup.length}
                    shouldAppendCode={true}
                    addCodeToEnd={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.code}
                    handleInputChange={(e) => {
                      setFormData({ code: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.description}
                    handleInputChange={(e) => {
                      setFormData({ description: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
            </div>
          )}
          {tabValue === 1 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-12 mb-3'>
                <h4 className='tab-title'>Media</h4>
                <ImageUpload
                  uploadedImages={formData.images.value}
                  imgList={rawImages}
                  onImageListUpdated={onImageListUpdated}
                  onUploadedImageRemoval={onUploadedImageRemoval}
                  onImagesLoading={(status) => setLoading(status)}
                  videoImageUrl={videoImageUrl}
                  onVideoImageUrlChange={setVideoImageUrl}
                  gifImageUrl={gifImageUrl}
                  onGifImageUrlChange={setGifImageUrl}
                  videoList={rawVideos}
                  gifList={rawGifs}
                  onVideoListUpdated={setRawVideos}
                  onGifListUpdated={setRawGifs}
                  hotelId={hotelId}
                  groupId={formData.groupId.value}
                  propertyType={ASSET_BRANDS}
                  onVideoError={setHasVideoError}
                  onThumbnailUploading={setIsThumbnailUploading}
                  onVideoLoading={setIsVideoLoading}
                  onGifLoading={setIsGifLoading}
                />
              </div>
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 1 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={isTabInValid || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {brand ? 'Update' : 'Save'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default BrandCreate;
